import { defineComponent as _defineComponent } from 'vue';
import { PAGE_TYPES_TO_ROUTES } from '~/constants/RoutesEnums';
import { useConvertToCamelCase } from '~/composables/useConvertToCamelCase';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryTagsGraphql',
  props: {
    tags: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app;
    function getRouteInfo(obj) {
      var pageType = obj === null || obj === void 0 ? void 0 : obj.__typename;
      if (!pageType) {
        console.error('Page type is undefined.');
        return null;
      }
      var camelCasePageType = useConvertToCamelCase(pageType);
      var routeName = PAGE_TYPES_TO_ROUTES === null || PAGE_TYPES_TO_ROUTES === void 0 ? void 0 : PAGE_TYPES_TO_ROUTES[camelCasePageType];
      if (!routeName) {
        console.error('Route name not found for page type:', camelCasePageType);
        return null;
      }
      var slug = obj === null || obj === void 0 ? void 0 : obj.slug;
      if (!slug) {
        console.error('Slug is undefined for page type:', camelCasePageType);
        return null;
      }
      return {
        routeName: routeName,
        slug: slug
      };
    }
    function getRoutePath(obj) {
      var routeInfo = getRouteInfo(obj);
      if (!routeInfo) {
        return false;
      }
      return app.localePath({
        name: routeInfo.routeName,
        params: {
          slug: routeInfo.slug
        }
      });
    }
    return {
      __sfc: true,
      app: app,
      props: props,
      getRouteInfo: getRouteInfo,
      getRoutePath: getRoutePath,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});